import React, { PureComponent } from 'react';
import ReactSVG from 'react-svg';


class LookWhosTalkingSlide extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            highlight: props.selectedIndex === props.index
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedIndex !== this.props.selectedIndex) {
            this.setState({ highlight: this.props.selectedIndex === this.props.index });
        }
    }


    render() {

        return (
            <div className={ this.state.highlight ? "logo-slide highlight" : "logo-slide" } >
                <ReactSVG path={ this.props.path } index={ this.props.index } wrapperClassName="svg-wrapper-logos" />
            </div>
        );
    }
}


export default LookWhosTalkingSlide;



// WEBPACK FOOTER //
// ./src/components/explain/LookWhosTalkingSlide.js